import {DuplicatedUserAlertError} from './DuplicatedUserAlertError.js'
import {GetUserAlertError} from './GetUserAlertError.js'
import {MaxLimitReachedUserAlertError} from './MaxLimitReachedUserAlertError.js'
import {SearchHasNoFiltersUserAlertError} from './SearchHasNoFiltersUserAlertError.js'
import {UpdateUserAlertsError} from './UpdateUserAlertError.js'
import {UserAlertsError} from './UserAlertsError.js'

export default class UserAlertsErrorsFactory {
  static searchHasNoFiltersUserAlertError = message => new SearchHasNoFiltersUserAlertError(message)

  static duplicatedUserAlertError = ({notAvailableFilters, message}) =>
    new DuplicatedUserAlertError({notAvailableFilters, message})

  static maxLimitReachedUserAlertError = ({code, message}) => new MaxLimitReachedUserAlertError({code, message})

  static getUserAlertError = message => new GetUserAlertError(message)
  // to-do: use correct error instances according to current user alert error
  static getUserAlertsError = message => new UserAlertsError(message)
  static deleteUserAlertsError = message => new UserAlertsError(message)
  static updateUserAlertsError = ({message, response}) => new UpdateUserAlertsError({message, response})
}
